/* tslint:disable */
/* eslint-disable */
/**
 * Ameta Availability API
 * A rest api for managing the ameta availability system
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SectionCounterDataSections1
 */
export interface SectionCounterDataSections1 {
    /**
     * 
     * @type {string}
     * @memberof SectionCounterDataSections1
     */
    availability: string;
}

export function SectionCounterDataSections1FromJSON(json: any): SectionCounterDataSections1 {
    return SectionCounterDataSections1FromJSONTyped(json, false);
}

export function SectionCounterDataSections1FromJSONTyped(json: any, ignoreDiscriminator: boolean): SectionCounterDataSections1 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'availability': json['availability'],
    };
}

export function SectionCounterDataSections1ToJSON(value?: SectionCounterDataSections1 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'availability': value.availability,
    };
}


